module.exports = __webpack_public_path__ + "mu.svg?01f12e8fd5517db2faf962e914b85d90";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mu.svg
// module id = 1329
// module chunks = 27